import React from 'react';
import MyCard from "../../components/myCard";
import {Button} from "react-bootstrap";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import IconTitle from "../../components/iconTitle";
import {faBan, faFilePdf, faUnlockAlt} from "@fortawesome/pro-solid-svg-icons";
import {getRoute} from "../../breadcrumb/utils";
import {toast} from "react-toastify";

class Consentement extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            rgpd: false,
            licence: false,
            consentement: false,
            memoire: {
                Remis: true,
            }
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.Memoire}`);

        if (body.MemoireConsentement) {
            this.props.history.push(getRoute(screens.RemiseMemoire));
        }

        this.setState({
            memoire: body
        });
    }

    async save() {

        if (this.state.rgpd === false || this.state.licence === false) {
            toast.warn("Complétez le formulaire ci-dessous pour pouvoir continuer plus loin..");
        } else {
            const data = new FormData();
            data.append("MemoireID", this.state.memoire.MemoireID);
            data.append("MemoireConsentementRGPD", this.state.rgpd);
            data.append("MemoireConsentementLicence", this.state.licence);

            await Post(`/v1/extranet/student/${screens.Memoire}`, Object.fromEntries(data), "Sauvegarde en cours..", {render: "Consentements sauvegardés !"}, {render: "Erreur lors de la sauvegarde"});

            this.props.history.push(getRoute(screens.RemiseMemoire));
        }

    }

    renderAccueil() {
        return (
            <>
                <p>
                    Tous les mémoires d’étudiants du Département ICHEC de la Haute Ecole sont déposés exclusivement de
                    manière électronique dans ICHEC Student (lié à la base de données Meteor) pour une période de 10
                    ans.
                </p>
                <p>
                    Seuls les mémoires dont l’auteur et l’institution ont autorisé l’accès sont consultables, le cas
                    échéant avec certaines restrictions plus amplement décrites ci-dessous.
                    <br/>
                    Ce système d’archivage et de consultation électronique présente de nombreux avantages :
                </p>
                <ul>
                    <li>Accessibilité 24/7</li>
                    <li>Mode d’accès unique et aisé</li>
                    <li>Visibilité plus large donnée aux travaux de recherche dans l’esprit « open access » souhaité par
                        l’institution
                    </li>
                    <li>Protection de l’environnement en évitant les versions « papier »</li>
                    <li>Utilisation d’un système d’aide à la détection du plagiat lors du dépôt électronique du
                        mémoire
                    </li>
                </ul>
                <p>
                    Le dépôt électronique des mémoires intègre une information sur les droits en matière de données à
                    caractère personnel ainsi qu’une licence par laquelle l’auteur du mémoire se prononce sur la future
                    diffusion de son travail. L’accessibilité à un public large se fait donc dans le respect du RGPD et
                    de la législation sur les droits d’auteur.
                </p>
            </>
        );
    }

    renderAccessibilite() {
        return (
            <>
                <p>
                    ICHEC Student répertorie tous les mémoires du Département ICHEC qui ont été déposés par les
                    étudiants en version électronique.
                    <br/>
                    Il les classe soit en accès ouvert, soit en accès restreint, soit en accès interdit.
                </p>
                <IconTitle type={"h5"} icon={faFilePdf} content={"Accès ouvert"}/>
                <p>
                    Le mémoire sera consultable dans son intégralité en « open access » sur le site PBM de la
                    bibliothèque
                </p>
                <ul>
                    <li>
                        Si l'étudiant
                        <ul>
                            <li>a donné son consentement RGPD, et ne l'a pas ensuite retiré</li>
                            <li>a octroyé une licence d’exploitation de ses droits d’auteur</li>
                        </ul>
                    </li>
                    <li>
                        Si le mémoire
                        <ul>
                            <li>n’est pas confidentiel ou que la date de fin de confidentialité est dépassée (fixée à 2
                                ans par défaut sauf demande expresse de l’entreprise)
                            </li>
                            <li>a obtenu une note égale ou supérieure à 14/20</li>
                        </ul>
                    </li>
                </ul>
                <p>
                    En cas de divergence entre l’auteur et l’institution sur l’accès à donner, l’accès le plus
                    restrictif l’emporte.
                </p>
                <br/>
                <IconTitle type={"h5"} icon={faUnlockAlt} content={"Accès restreint"}/>
                <p>
                    Le mémoire sera consultable dans son intégralité mais seulement par les étudiants, promoteurs,
                    enseignants, membres du jury et membres du personnel chargés de leur gestion administrative
                </p>
                <ul>
                    <li>
                        Si l'étudiant
                        <ul>
                            <li>a donné son consentement RGPD, et ne l'a pas ensuite retiré</li>
                            <li>a octroyé une licence d’exploitation de ses droits d’auteur</li>
                        </ul>
                    </li>
                    <li>
                        Si le mémoire
                        <ul>
                            <li>n’est pas confidentiel ou que la date de fin de confidentialité est dépassée (fixée à 2
                                ans par défaut sauf demande expresse de l’entreprise)
                            </li>
                            <li>a obtenu une note égale ou supérieure à 12/20 et inférieure à 14/20</li>
                        </ul>
                    </li>
                </ul>
                <br/>
                <IconTitle type={"h5"} icon={faBan} content={"Accès interdit"}/>
                <p>
                    Le contenu du mémoire ne sera pas disponible si au moins une des conditions suivantes se présente :
                </p>
                <ul>
                    <li>
                        Si l’étudiant
                        <ul>
                            <li>
                                n’a pas donné son consentement sur l’utilisation de ses données personnelles (ou l’a
                                retiré)
                            </li>
                            <li>n’a pas octroyé une licence d’exploitation de ses droits d’auteur</li>
                        </ul>
                    </li>
                    <li>
                        Si le mémoire est confidentiel
                        <ul>
                            <li>
                                Si la confidentialité a été demandée,
                                <ul>
                                    <li>
                                        cette confidentialité est respectée jusqu’à la date d’expiration (fixée à 2 ans
                                        par défaut sauf demande expresse de l’entreprise)
                                    </li>
                                    <li>
                                        après cette date, si l’auteur souhaite que le mémoire soit visible, il lui est
                                        demandé de donner dès maintenant sa licence d’exploitation et son consentement
                                        RGPD afin que l’ICHEC puisse rendre le mémoire accessible dès la date
                                        d’expiration
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        Si l’ICHEC a refusé l’accès à un mémoire (en attente de délibération ou note inférieure à 12/20)
                    </li>
                </ul>
            </>
        );
    }

    renderRGPD() {
        return (
            <>
                <p>
                    J'ai lu la&nbsp;
                    <a rel="noopener noreferrer" target="_blank"
                       href="https://files.ichec.be/ICHEC-Memoires-Vie-Privee.pdf">politique de vie privée</a> et
                </p>
                <p>
                    <label className={"px-5"}>
                        <input type="radio" name="rgpd" value="true"
                               onChange={(changeEvent) => {
                                   this.setState({
                                       rgpd: changeEvent.target.value
                                   });
                               }}
                        />&nbsp;Je donne mon consentement pour les finalités catalogue et publication des mémoires : mon
                        nom et prénom, et le contenu pourront être repris dans le catalogue de mémoires
                    </label>
                </p>
                <p>
                    <label className={"px-5"}>
                        <input type="radio" name="rgpd" value="false"
                               onChange={(changeEvent) => {
                                   this.setState({
                                       rgpd: changeEvent.target.value
                                   });
                               }}
                        />&nbsp;Je ne donne pas mon consentement pour les finalités catalogue et publication des
                        mémoires ; mon nom et prénom, et le contenu ne seront pas repris dans le catalogue de mémoires
                    </label>
                </p>
            </>
        );
    }

    renderLicence() {
        return (
            <>
                <p>
                    <label>
                        <input type="radio" name="licence" value="true" className={"mr-3"}
                               onChange={(changeEvent) => {
                                   this.setState({
                                       licence: changeEvent.target.value
                                   });
                               }}
                        />J'accepte que mon mémoire soit consultable en libre accès.
                    </label>

                </p>
                <div className={"font-weight-light font-italic pl-5 pr-1"}>
                    <small>
                        En cochant cette case, j’octroie à la Haute Ecole « ICHEC-ECAM-ISFSC », département ICHEC, une
                        licence immédiate d’exploitation non exclusive sur mes droits d’auteur. Cette licence est
                        concédée à l’ICHEC à titre gratuit, pour toute la durée légale des droits d’auteur et pour le
                        monde entier.
                        <br/>
                        J’autorise ainsi l’ICHEC à : – accomplir tout acte technique nécessaire à l’archivage et à la
                        conservation de mon mémoire dans le répertoire institutionnel de l’ICHEC ; - reproduire ou
                        autoriser à reproduire le mémoire sur papier ou sur tout autre support/format
                        électronique/numérique sur les sites Internet de l’ICHEC et sur les serveurs nécessaires à la
                        diffusion ; – établir tout lien hypertexte utile et conforme aux usages à partir ou en direction
                        du site où le mémoire est reproduit ; – communiquer mon mémoire au public en le mettant en
                        circulation sur le réseau Internet à partir des sites Internet de l’ICHEC et sur tout autre type
                        de réseaux informatiques ; – adapter éventuellement les paramètres de présentation de mon
                        mémoire en vue de son intégration dans le répertoire institutionnel de l’ICHEC et de sa
                        diffusion en ligne (typographie, format, police de caractère, couleur, contrastes, taille et dpi
                        des éléments graphiques, etc.).
                        <br/>
                        L’utilisateur de cette licence d’exploitation sera informé qu’il ne sera autorisé à reproduire
                        mon mémoire qu’à des fins d’usage privé ou à des fins d’illustration de l’enseignement ou de
                        recherche scientifique, et dans un but non lucratif.
                    </small>
                </div>
                <br/>
                <p>
                    <label>
                        <input type="radio" name="licence" value="false" className={"mr-3"}
                               onChange={(changeEvent) => {
                                   this.setState({
                                       licence: changeEvent.target.value
                                   });
                               }}
                        />Je refuse que mon mémoire soit consultable en libre accès.
                    </label>

                </p>
                <div className={"font-weight-light font-italic pl-5 pr-1"}>
                    <small>
                        Mon mémoire sera cependant archivé électroniquement sur les sites ad hoc de l’ICHEC. Son
                        auteur*, (ses) titre(s), mot(s)-clé(s) et son (ses) promoteur(s) seront seuls référencés dans le
                        catalogue, mais personne ne pourra consulter son contenu sous quelle forme que ce soit.
                        <br/>
                        * sauf dans le cas où je n’ai pas donné mon consentement à l’emploi de mes informations
                        personnelles tel que décrit dans la politique de vie privée, cf. ci-dessus.
                    </small>
                </div>
            </>
        );
    }

    render() {
        return (
            <section>
                {this.state.consentement
                    ?
                    <>
                        <MyCard header={"Règlement Général sur la Protection des Données"}
                                body={this.renderRGPD()}/>
                        <br/>
                        <MyCard header={"Cession des droits de propriété intellectuelles"}
                                body={this.renderLicence()}/>
                        <br/>
                        <div className={"text-center"}>
                            <Button variant={"secondary"} size={"lg"}
                                    onClick={() => this.save()}>Remise du mémoire</Button>
                        </div>
                    </>
                    :
                    <>
                        <MyCard header={"Principes généraux"}
                                body={this.renderAccueil()}/>
                        <br/>
                        <MyCard header={"Gestion de l’accès à un mémoire"}
                                body={this.renderAccessibilite()}/>
                        <br/>
                        <div className={"text-center"}>
                            <Button variant={"secondary"}
                                    onClick={() => {
                                        this.setState({consentement: true});
                                        document.body.scrollTo = 0;
                                        document.documentElement.scrollTop = 0;
                                    }}
                                    size={"lg"}>Suite &gt;&gt;</Button>
                        </div>
                    </>
                }
            </section>
        );
    }

}

export default withRouter(Consentement);